(ns frontend.actions.account
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]
   [frontend.logging :as logging]))

;; NOTE
;; Should be one-to-one mapping with domain/account
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *->re-invite-guest
  [data on-success! on-error!]
  (-> (conn/sendp! :account/re-invite-guest
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-guest
  [data on-success! on-error!]
  (-> (conn/sendp! :account/update-guest
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->invite-guest
  [data on-success! on-error!]
  (-> (conn/sendp! :account/invite-guest
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-preferences
  [data on-success! on-error!]
  (-> (conn/sendp! :account/update-preferences
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->recalculate-permissions
  [data on-success! on-error!]
  (-> (conn/sendp! :account/recalculate-permissions
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->accept-terms
  [on-success! on-error!]
  (-> (conn/sendp! :account/accept-terms
                   {})
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->reset-password
  [data on-success! on-error!]
  (-> (conn/sendp! :account/reset-password
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-personal
  [data on-success! on-error!]
  (-> (conn/sendp! :account/update-personal
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-view-config
  [data on-success! on-error!]
  (-> (conn/sendp! :account/update-view-config
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->disable
  [data on-success! on-error!]
  (-> (conn/sendp! :account/disable!
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn update-preferences
  [new-prefs]
  (let [data {:account/preference new-prefs}]
    (*->update-preferences data
                           (partial logging/unimplemented "success updating preferences")
                           (partial logging/error "Error updating preferences"))))

(defn *->reset-mfa
  [data on-success! on-error!]
  (-> (conn/sendp! :account/reset-mfa
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->assign-mfa
  [data on-success! on-error!]
  (-> (conn/sendp! :account/assign-mfa
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->deactivate-mfa
  [data on-success! on-error!]
  (-> (conn/sendp! :account/deactivate-mfa
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->tokens
  [msg on-success! on-error!]
  (-> (conn/sendp! :account/get-tokens
                   msg)
      (p/then on-success!)
      (p/catch on-error!)))
